// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {TextField} from '@wandb/weave/components/Form/TextField';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useState} from 'react';
import {toast} from 'react-toastify';

import {useUpdateProjectAdminMutation} from '../../generated/graphql';

type ProjectRateLimitInputProps = {
  projectID: string;
  originalLimit: number;
  limitUnitLabel: string;
  limitName: string;
  limitTitle: string;
};

const ProjectRateLimitInput = ({
  originalLimit,
  projectID,
  limitUnitLabel,
  limitName,
  limitTitle,
}: ProjectRateLimitInputProps) => {
  const [updateProject, {loading}] = useUpdateProjectAdminMutation();
  const [newLimit, setNewLimit] = useState(originalLimit.toString());

  const savingDisabled =
    newLimit === originalLimit.toString() || loading || newLimit === '';

  const onClickSave = async () => {
    if (projectID == null || savingDisabled) {
      return;
    }
    try {
      await updateProject({
        variables: {
          id: projectID,
          rateLimits: {
            [limitName]: Number(newLimit),
          },
        },
      });
      toast(`Successfully updated ${limitTitle} rate limit`);
    } catch (err) {
      toast(`Error updating ${limitTitle} rate limit`, {
        type: 'error',
      });
      console.error(`error updating ${limitTitle} rate limit`, err);
    }
  };

  return (
    <Tailwind>
      <div className="flex w-[240px] gap-x-2">
        <TextField
          extraActions={
            <p className="select-none pl-8 pr-4 text-sm text-moon-500">
              {limitUnitLabel}
            </p>
          }
          type="number"
          value={newLimit}
          onChange={setNewLimit}
        />
        <Button size="small" disabled={savingDisabled} onClick={onClickSave}>
          Save
        </Button>
      </div>
    </Tailwind>
  );
};

export default ProjectRateLimitInput;
